module.exports = __webpack_public_path__ + "img/mastercard.32f991b.png";